import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React from 'react';

import Button from '../../../../r/components/shared/button';
import { ForgotPasswordWrapper } from './styled';

const ForgotPassword = () => {
  const { feedback } = useSelector((state) => state.auth);
  const history = useHistory();

  const changePage = () => history.push('/auth/reset-password');

  return (
    <ForgotPasswordWrapper>
      <Button
        disabled={feedback.isLoading}
        text="Forgot Password?"
        onClick={changePage}
        variant="link"
        size="small"
      />
    </ForgotPasswordWrapper>
  );
};

export default ForgotPassword;